import React, { useState, useEffect } from "react"
import { Container, Input, Button, Row, Col, } from "reactstrap";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { RiFileExcel2Line } from "react-icons/ri";

export function ApprovalConsiderationAnnounceFourComponent() {
    const user = JSON.parse(localStorage.getItem("userData"));
    const [listStartMonth, setListStartMonth] = useState([]);
    // console.log("listStartMonth", listStartMonth);
    const [listEndMonth, setListEndMonth] = useState([]);
    // console.log("listEndMonth", listEndMonth);
    const [startMonth, setStartMonth] = useState(0);
    // console.log("startMonth", startMonth);
    const [endMonth, setEndMonth] = useState(0);
    // console.log("endMonth", endMonth);
    const [listStartBudgetYear, setListStartBudgetYear] = useState([]);
    // console.log("listStartBudgetYear", listStartBudgetYear);
    const [listEndBudgetYear, setListEndBudgetYear] = useState([]);
    const [startBudgetYear, setStartBudgetYear] = useState(0);
    const [endBudgetYear, setEndBudgetYear] = useState(0);
    const [approvalResult, setApprovalResult] = useState([]);
    useEffect(() => {
        GetMonthMasterData();
        GetBudgetYear();
    }, [])

    async function GetMonthMasterData() {
        try {
            let res = await fetch("/api/MasterData/getMasterMonth")
            let resJson = await res.json();
            setListStartMonth(resJson.dataenum);
            setListEndMonth(resJson.dataenum);
        } catch (e) {
            console.log(e);
        }
    }

    async function GetBudgetYear() {
        try {

            let res = await fetch("/api/MasterData/getBudgetYear")
            let resJson = await res.json();
            // console.log("year", resJson.dataenum);
            setListStartBudgetYear(resJson.dataenum);
            setListEndBudgetYear(resJson.dataenum);
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        async function GetApprovalAnnounceFour() {
            if (startMonth === 0 || endMonth === 0 || startBudgetYear === 0 || endBudgetYear === 0) {
                return;
            } else {
                let postData = new FormData();
                postData.append("startMonth", startMonth);
                postData.append("endMonth", endMonth);
                postData.append("startBudgetYear", startBudgetYear);
                postData.append("endBudgetYear", endBudgetYear);
                let res = await fetch("/api/ApprovalConsiderationResult/getApprovalAnnounceFour", {
                    method: "POST",
                    headers: {
                        "token": user.token
                    },
                    body: postData
                })
                let resJson = await res.json();
                setApprovalResult(resJson.dataenum);
            }
        }
        GetApprovalAnnounceFour();
    }, [startMonth, endMonth, startBudgetYear, endBudgetYear])
    return (
        <Container>
            <div className="d-flex flex-wrap justify-content-center align-items-center mb-4">
                <div className="d-flex justify-content-center align-items-center">
                    <Input
                        type="select"
                        className={`rounded-pill rounded-end text-center input-color w-100`}
                        onChange={(e) => setStartMonth(e.target.value)}
                        value={startMonth}
                    >
                        <option value={0}>--เดือน--</option>
                        {listStartMonth.map(month => (
                            <option value={Number(month.monthNumber)}>{month.monthName}</option>
                        ))}

                    </Input>
                    <Input
                        type="select"
                        className="border border-1 rounded-pill rounded-start text-center input-color w-75"
                        onChange={(e) => setStartBudgetYear(e.target.value)}
                        value={startBudgetYear}
                    >
                        <option value={Number(0)}>--ปี--</option>
                        <option value={Number(2565)}>2565</option>
                        <option value={Number(2566)}>2566</option>
                        <option value={Number(2567)}>2567</option>
                        <option value={Number(2568)}>2568</option>
                        <option value={Number(2569)}>2569</option>
                        <option value={Number(2570)}>2570</option>
                        <option value={Number(2571)}>2571</option>
                        <option value={Number(2572)}>2572</option>
                    </Input>
                </div>
                <h5 className="mx-4">
                    ถึง
                </h5>
                <div className="d-flex justify-content-center align-items-center">
                    <Input
                        type="select"
                        className={`rounded-pill rounded-end text-center input-color w-100`}
                        onChange={(e) => setEndMonth(e.target.value)}
                        value={endMonth}
                    >
                        <option value={0}>--เดือน--</option>
                        {listEndMonth.map(month => (
                            <option value={Number(month.monthNumber)}>{month.monthName}</option>
                        ))}

                    </Input>
                    <Input
                        type="select"
                        className="border border-1 rounded-pill rounded-start text-center input-color w-75"
                        onChange={(e) => setEndBudgetYear(e.target.value)}
                        value={endBudgetYear}
                    >
                        <option value={0}>--ปี--</option>
                        <option value={2565}>2565</option>
                        <option value={2566}>2566</option>
                        <option value={2567}>2567</option>
                        <option value={2568}>2568</option>
                        <option value={2569}>2569</option>
                        <option value={2570}>2570</option>
                        <option value={2571}>2571</option>
                        <option value={2572}>2572</option>
                    </Input>
                </div>
            </div>
            <Row className='mb-3'>
                <Col className='d-flex justify-content-end'>
                    <Button
                        // disabled={firstYearSelected === "0" || secondYearSelected === "0" ? true : false}
                        className="btn border border-1 mx-1 btn-green"
                        href={`api/ApprovalConsiderationResult/exportApprovalAnnounceFour?startMonth=${startMonth}&endMonth=${endMonth}&startBudgetYear=${startBudgetYear}&endBudgetYear=${endBudgetYear}`}
                        download
                    >
                        <RiFileExcel2Line />
                        Export Excel
                    </Button>
                </Col>
            </Row>
            <div className="outer-wrapper">
                <div className="table-wrapper overflow-auto">
                    <table>
                        <thead>
                            <tr>
                                <th rowSpan="2">ลำดับ</th>
                                <th rowSpan="2">เลขที่คำขอ</th>
                                <th rowSpan="2">
                                    ชื่อผู้ขอรับเงินช่วยเหลือ หรืออุดหนุน
                                </th>
                                <th colSpan="5">
                                    ผู้ดำเนินการทดสอบฯ ตามมาตรา 26
                                </th>
                                <th rowSpan="2">
                                    จำนวนเงินช่วยเหลือหรืออุดหนุน (บาท)
                                </th>
                                <th rowSpan="2">
                                    วันที่จ่ายเงินช่วยเหลือหรืออุดหนุน
                                </th>
                            </tr>
                            <tr>
                                <th>ปี พ.ศ.</th>
                                <th>จำนวนผู้ผ่านการทดสอบฯ (คน)</th>
                                <th>สาขาอาชีพ</th>
                                <th>สาขา</th>
                                <th>จำนวน (คน)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {approvalResult.length > 0 ? approvalResult.map((item, i) => (
                                <>
                                    {item.detailLawOccupationReports.map((detail, index) => (
                                        <tr key={item.supportId + index}>
                                            {index === 0 && (
                                                <>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {i + 1}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {item.supportNo}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {item.supportedName}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.year}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.passTest}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.lawOccupationName}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.testOccupationName}
                                                    </td>
                                                    <td className="text-center">
                                                        {NumberWithCommas(detail.personTotal)}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {NumberWithCommas(item.paymentAmount)}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {item.paymentDate}
                                                    </td>
                                                </>
                                            )}
                                            {index >= 1 && (
                                                <>
                                                    <td className="text-center">
                                                        {detail.year}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.passTest}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.lawOccupationName}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.testOccupationName}
                                                    </td>
                                                    <td className="text-center">
                                                        {NumberWithCommas(detail.personTotal)}
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    ))}
                                </>
                            )) : (
                                <tr>
                                    <td
                                        className="text-center"
                                        colSpan="10"
                                    >
                                        ไม่มีข้อมูล
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

        </Container>
    )
}